import { render, staticRenderFns } from "./sidebarnav.vue?vue&type=template&id=5dfe9e28&scoped=true&lang=pug"
import script from "./sidebarnav.vue?vue&type=script&lang=js"
export * from "./sidebarnav.vue?vue&type=script&lang=js"
import style0 from "./sidebarnav.vue?vue&type=style&index=0&id=5dfe9e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe9e28",
  null
  
)

export default component.exports